'use strict';


const
    storage = require('../../../plugin-ufs/src/js/universal.storage'),
    save = storage.save,
    load = storage.load,
    defaultFilename = 'config';

/**
 * core.module.ufsJson.load(function ( error, data) { ... });
 * core.module.ufsJson.save(, {qwe: 123});
 *
 * core.module.ufsJson.filename = 'config';
 *
 * core.module.ufsJson.loadSync();
 * core.module.ufsJson.saveSync({qwe: 123});
 *
 */
class UfsJson {
    constructor ( appName ) {
        // create read-only property for own app files
        Object.defineProperty(this, 'appName', {
            value: appName,
            enumerable: false,
            configurable: false,
            writable: false
        });
    }

    /**
     * Asynchronously load data from '/mnt/Userfs/data/%appName%.config' file.
     *
     * @param {Function} [callback] - result callback
     *
     * @example
     * // load data from '/mnt/Userfs/data/%appName%.config'
     * core.plugins.ufsJson.load(function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *
     *     console.log(data);
     * });
     *
     * // load data from '/mnt/Userfs/data/%appName%.meta.info'
     * core.plugins.ufsJson.fileName = 'meta.info';
     *
     * core.plugins.ufsJson.load(function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     */
    load ( callback ) {
        let self = this;

        setTimeout(function () {
            let data = load(self.appName + '.' + self.filename + '.json'),
                error;

            try {
                data = JSON.parse(data);
                error = null;
            } catch ( parseError ) {
                error = parseError;
            }

            callback(error, data);
        }, 0);
    }

    /**
     * Synchronously load data from '/mnt/Userfs/data/%appName%.config' file.
     *
     * @return {string|null} data file content string
     *
     * @example
     * // load data from '/mnt/Userfs/data/%appName%.config'
     * console.log(core.plugins.ufsJson.loadSync());
     *
     * // save data to '/mnt/Userfs/data/%appName%.meta.info.json'.
     * core.plugins.ufsJson.fileName = 'meta.info';
     *
     * console.log(core.plugins.ufsJson.loadSync());
     */
    loadSync () {
        let data = load(this.appName + '.' + this.filename + '.json');

        try {
            data = JSON.parse(data);
        } catch ( error ) {
            data = null;
        }

        return data;
    }


    /**
     * Asynchronously save data to file '/mnt/Userfs/data/%appName%.config'.
     *
     * @param {string} data - data to save
     * @param {Function} [callback] - result callback
     *
     *
     * @example
     * // save data to '/mnt/Userfs/data/%appName%.config'
     * core.plugins.ufsJson.save([1,2,3,4], function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     *
     * // save data to '/mnt/Userfs/data/%appName%.meta.info.json'
     * core.plugins.ufsJson.fileName = 'meta.info';
     *
     * core.plugins.ufsJson.save([1,2,3,4], function ( error, data ) {
     *     if ( error ) {
     *         throw error;
     *     }
     *     console.log(data);
     * });
     */
    save ( data, callback ) {
        let self = this;

        setTimeout(function () {
            try {
                data = JSON.stringify(data);
            } catch ( error ) {
                if ( typeof callback === 'function' ) {
                    callback(error, null);
                }

                return;
            }

            save(self.appName + '.'  + self.filename + '.json', data);

            if ( typeof callback === 'function' ) {
                callback(null, data);
            }
        }, 0);
    }

    /**
     * Synchronously save data to file '/mnt/Userfs/data/%appName%.config'.
     *
     * @param {string} data - data to save
     * @return {boolean} save status
     *
     * @example
     *
     * // save data to '/mnt/Userfs/data/%appName%.config'
     * core.plugins.ufsJson.saveSync([1,2,3,4]);
     *
     * // save data to '/mnt/Userfs/data/%appName%.meta.info.json'
     * core.plugins.ufsJson.fileName = 'meta.info';
     *
     * core.plugins.ufsJson.saveSync([1,2,3,4]);
     */
    saveSync ( data ) {
        try {
            data = JSON.stringify(data);
            save(this.appName + '.' + this.filename + '.json', data);

            return true;
        } catch ( error ) {
            return false;
        }
    }
}

/**
 * Custom app file name postfix.
 *
 * @type {string}
 */

UfsJson.prototype.filename = defaultFilename;


module.exports = UfsJson;
